import React from 'react';
import { useTranslation } from 'react-i18next';
import { SlotPrefillStatus } from '../useSlotPrefill';

// Why the object picked in the week calendar is not selected (yet). Shown
// under the object field so a prefill that could not be applied never reads
// as a form that simply forgot it.

const SlotPrefillNote: React.FC<{ status: SlotPrefillStatus }> = ({ status }) => {
    const { t } = useTranslation();
    if (status === 'none' || status === 'selected') return null;
    return (
        <p className={'text-sm text-foreground/60 mt-1'} role={'status'}>
            {t(`create_booking.slot_prefill.${status}`)}
        </p>
    );
};

export default SlotPrefillNote;
